import { BottomSheet } from '@/components/ui';
import React, { useEffect } from 'react';
import {
  NeighborhoodMapMobileContent,
  NeighborhoodMapMobileFooter,
} from './components/NeighborhoodMapMobile';
import { LocationFilterContent } from './LocationFilterContent';
import { FilterActionBar } from '../FilterActionBar';
import { useStore } from '@/providers/StoreProvider';
import { useAnalytics } from '@/hooks/useAnalytics';

export interface LocationFilterMobileProps {
  open: boolean;
  onClose: () => void;
  requireConfirmation?: boolean;
}

export function LocationFilterMobile({
  open,
  onClose,
  requireConfirmation,
}: LocationFilterMobileProps) {
  const [searchQuery, setSearchQuery] = React.useState('');
  const [showMap, setShowMap] = React.useState(false);
  const isSearching = searchQuery.trim().length > 0;

  const analytics = useAnalytics();
  const neighborhoodIds = useStore(s => s.listingsFilters.neighborhoodIds);

  const resetNeighborhoods = useStore(s => s.listingsFilters.resetNeighborhoods);
  const resetBuilding = useStore(s => s.listingsFilters.resetBuilding);
  const getUrlFilterPayload = useStore(s => s.listingsFilters.getUrlFilterPayload);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchQuery('');
    }, 300);
    return () => clearTimeout(timeout);
  }, [neighborhoodIds]);

  return (
    <>
      <BottomSheet
        label={showMap ? 'All neighborhoods' : 'Select location'}
        fullHeight={true}
        bodyClassName={showMap ? '!px-0 !py-0' : '!px-2'}
        leading={false}
        open={open}
        onClose={() => {
          setShowMap(false);
          onClose();
        }}
        {...(showMap
          ? {
              onBack: () => {
                analytics.track('listings_filter_allneighborhoods_map_goback');
                setShowMap(false);
              },
            }
          : {})}
        footer={
          showMap ? (
            <NeighborhoodMapMobileFooter onDone={() => setShowMap(false)} />
          ) : isSearching ? null : (
            <FilterActionBar
              scope="location"
              {...(!requireConfirmation
                ? { primaryButtonText: 'Done', shouldUpdateUrl: false }
                : {})}
              onApply={() => {
                analytics.track('listings_filter_neighborhood_seeresults', {
                  selectedNeighborhoods: neighborhoodIds,
                });
                onClose();
              }}
              onReset={() => {
                analytics.track('listings_filter_neighborhood_reset');
                resetBuilding();
                resetNeighborhoods();
                const urlPayload = getUrlFilterPayload();
                window.history.replaceState(
                  null,
                  '',
                  urlPayload ? `/listings/${urlPayload}` : '/listings',
                );
                onClose();
              }}
            />
          )
        }
      >
        {showMap ? (
          <NeighborhoodMapMobileContent onDone={() => setShowMap(false)} />
        ) : (
          <LocationFilterContent
            searchQuery={searchQuery}
            onSearchQueryChange={setSearchQuery}
            variant="mobile"
            onViewMap={() => {
              analytics.track('listings_filter_allneighborhoods_map_seeall');
              setShowMap(true);
            }}
            showSearchInput
            className="h-full"
          />
        )}
      </BottomSheet>
    </>
  );
}

export default LocationFilterMobile;
